import useOpenHouses from './use-open-houses';

export default useOpenHouses;